import { recipeV2Client } from '../../../app/services/api/recipeV2';

/**
 * Hook that provides Recipe V2 API methods.
 * Calls go through the service client (intercepted by MSW in demo mode).
 */
const useRecipeV2Api = () => {
  return recipeV2Client;
};

export default useRecipeV2Api;
